module.exports = __webpack_public_path__ + "static/media/profile2.57cf0686.jpg";